import React, { useState } from 'react'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import Table from './role-table'
import Filters from './filters'
import BuildRole from './BuildRole'

function Roles() {
  const emptyParams = {
    search: '',
    department_id: '',
    permission_id: '',
    conflict_id: '',
    role_id: '',
    orderBy: 'role_sod_counts.score',
    orderDirection: 'desc',
    groupBy: 'role',
    category: '',
    role_type: '',
    score: '',
    showDeleted: false,
    perPage: 10,
    page: 1
  }
  const [filterParams, setFilterParams] = useState(emptyParams)
  const [showBuilder, setShowBuilder] = useState(false)

  const crumbs = [
    { name: 'Access Management', url: 'duties' },
    { name: 'Roles', url: '' }
  ]

  return (
    <Page title={'Roles'}>
      <PageTitle breadcrumbs={crumbs} />

      <div className="my-4">
        <Filters
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          setShowBuilder={setShowBuilder}
          dataType="Role"
        />
      </div>

      <Table filterParams={filterParams} setFilterParams={setFilterParams} />
      <BuildRole show={showBuilder} setShow={setShowBuilder} />
    </Page>
  )
}

export default Roles
